import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { prefilledListingFromCSP } from '@reverbdotcom/commons/src/url_helpers';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { Paths } from './shared/url_helpers';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

import SellYoursTop from '../../images/sell-flow/sell-yours-top.jpg';
import SellYoursBottom from '../../images/sell-flow/sell-yours-bottom.jpg';

interface IProps {
  csp: {
    id?: string;
    title?: string;
  }
}

export default function SellYoursCTA({ csp }: IProps) {
  if (!csp) { return null; }
  const { id, title: cspTitle } = csp;

  if (!(id && cspTitle)) { return null; }

  return (
    <div className="sell-yours-cta">
      <img
        className="sell-yours-cta__image"
        src={SellYoursTop}
        alt={I18n.t('discovery.sellYoursCTA.imageAlt')}
      />
      <div className="sell-yours-cta__content">
        <h3 className="sell-yours-cta__title">
          {I18n.t('discovery.sellYoursCTA.title')}
        </h3>
        <div className="sell-yours-cta__copy">
          <Translate
            html
            text="discovery.sellYoursCTA.copy"
            args={{
              cspTitle,
              linkOpen: `<a href=${Paths.sellingPage.expand({})} target="_blank">`,
              linkClose: '</a>',
            }}
          />
        </div>
        <CoreLink
          className="sell-yours-cta__button"
          to={prefilledListingFromCSP(id)}
          target="_blank"
          clickEvent={{
            eventName: MParticleEventName.ClickedComponent,
            componentName: 'SellYoursCTA',
            entityType: 'url',
            entityId: prefilledListingFromCSP(id),
          }}
        >
          {I18n.t('discovery.sellYoursCTA.button')}
        </CoreLink>
      </div>
      <img
        className="sell-yours-cta__image"
        src={SellYoursBottom}
        alt={I18n.t('discovery.sellYoursCTA.imageAlt')}
      />
    </div>
  );
}
